import React from 'react';
import {FormattedDate, FormattedRelative} from 'react-intl';

class DateComponent extends React.Component {

	render() {
		const date = new Date(this.props.date);
		
		const showTime = this.props.showTime || false;
		if(this.props.relative === true)
			return <FormattedRelative value={date} />
		else {
			if(showTime)
				return <FormattedDate value={date} 
						day="numeric" month="short" year="numeric" 
						minute={"numeric"} second={"numeric"} hour={"numeric"} />
			else
				return <FormattedDate value={date} 
						day="numeric" month="long" year="numeric" />
		}
			
	}
}

export default DateComponent;


// WEBPACK FOOTER //
// ./src/views/DateComponent.js